import { gql } from "../generated/gql";

export const getStreams = gql(/* GraphQL */ `
  query getStreams($first: Int!, $skip: Int!, $subgraphId: BigInt!) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: { subgraphId_lt: $subgraphId }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreamIdentifiers = gql(/* GraphQL */ `
  query getStreamIdentifiers($first: Int!, $skip: Int!) {
    streams(
      first: $first
      skip: $skip
      orderBy: timestamp
      orderDirection: desc
    ) {
      id
      alias
    }
  }
`);

export const getStreams_BySender = gql(/* GraphQL */ `
  query getStreams_BySender(
    $first: Int!
    $skip: Int!
    $sender: Bytes!
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: {
        or: [
          { and: [{ sender: $sender }, { subgraphId_lt: $subgraphId }] }
          { and: [{ proxender: $sender }, { subgraphId_lt: $subgraphId }] }
        ]
      }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreams_ByRecipient = gql(/* GraphQL */ `
  query getStreams_ByRecipient(
    $first: Int!
    $skip: Int!
    $recipient: Bytes
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: { recipient: $recipient, subgraphId_lt: $subgraphId }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreams_ByIds = gql(/* GraphQL */ `
  query getStreams_ByIds(
    $first: Int!
    $skip: Int!
    $streamIds: [String!]
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: { id_in: $streamIds, subgraphId_lt: $subgraphId }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreams_BySenderOrByRecipient = gql(/* GraphQL */ `
  query getStreams_BySenderOrByRecipient(
    $first: Int!
    $skip: Int!
    $recipient: Bytes!
    $sender: Bytes!
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: {
        or: [
          { and: [{ sender: $sender }, { subgraphId_lt: $subgraphId }] }
          { and: [{ proxender: $sender }, { subgraphId_lt: $subgraphId }] }
          { and: [{ recipient: $recipient }, { subgraphId_lt: $subgraphId }] }
        ]
      }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreams_BySender_ByIds = gql(/* GraphQL */ `
  query getStreams_BySender_ByIds(
    $first: Int!
    $skip: Int!
    $sender: Bytes
    $streamIds: [String!]
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: {
        or: [
          {
            and: [
              { sender: $sender }
              { id_in: $streamIds }
              { subgraphId_lt: $subgraphId }
            ]
          }
          {
            and: [
              { proxender: $sender }
              { id_in: $streamIds }
              { subgraphId_lt: $subgraphId }
            ]
          }
        ]
      }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreams_ByRecipient_ByIds = gql(/* GraphQL */ `
  query getStreamsBy_Recipient_ByIds(
    $first: Int!
    $skip: Int!
    $recipient: Bytes
    $streamIds: [String!]
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: {
        recipient: $recipient
        id_in: $streamIds
        subgraphId_lt: $subgraphId
      }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStream_ById = gql(/* GraphQL */ `
  query getStream_ById($streamId: ID!) {
    stream(id: $streamId) {
      ...StreamFragment
    }
  }
`);

export const getStreams_BySenderOrByRecipient_ByIds = gql(/* GraphQL */ `
  query getStreams_BySenderOrByRecipient_ByIds(
    $first: Int!
    $skip: Int!
    $sender: Bytes
    $recipient: Bytes
    $streamIds: [String!]
    $subgraphId: BigInt!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: {
        or: [
          {
            and: [
              { sender: $sender }
              { id_in: $streamIds }
              { subgraphId_lt: $subgraphId }
            ]
          }
          {
            and: [
              { proxender: $sender }
              { id_in: $streamIds }
              { subgraphId_lt: $subgraphId }
            ]
          }
          {
            and: [
              { recipient: $recipient }
              { id_in: $streamIds }
              { subgraphId_lt: $subgraphId }
            ]
          }
        ]
      }
    ) {
      ...StreamFragment
    }
  }
`);

export const getStreamIds_ByRecipient = gql(/* GraphQL */ `
  query getStreamIds_ByRecipient(
    $first: Int!
    $skip: Int!
    $recipient: Bytes!
  ) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: { recipient: $recipient }
    ) {
      id
    }
  }
`);

export const getStreamIds_BySender = gql(/* GraphQL */ `
  query getStreamIds_BySender($first: Int!, $skip: Int!, $sender: Bytes!) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: { or: [{ sender: $sender }, { proxender: $sender }] }
    ) {
      id
    }
  }
`);

export const getStreamIds_ByParties = gql(/* GraphQL */ `
  query getStreamIds_ByParties($first: Int!, $skip: Int!, $parties: [Bytes!]!) {
    streams(
      first: $first
      skip: $skip
      orderBy: subgraphId
      orderDirection: desc
      where: { parties_contains: $parties }
    ) {
      id
    }
  }
`);

export const getActions_ByStream = gql(/* GraphQL */ `
  query getActions_ByStream(
    $first: Int!
    $streamId: String!
    $subgraphId: BigInt!
  ) {
    actions(
      first: $first
      orderBy: subgraphId
      orderDirection: desc
      where: { stream: $streamId, subgraphId_lt: $subgraphId }
    ) {
      ...ActionFragment
      stream {
        id
        asset {
          ...AssetFragment
        }
      }
    }
  }
`);
